module.exports = __webpack_public_path__ + "static/media/shiny_enterprise.9cc73099.jpg";